import React from "react";
import { Button } from "react-bootstrap";
import myformat from "dateformat";
import { toast } from "react-toastify";
import AxiosInstance from "../../utils/AxiosInstance";

export const Reviews = ({ review, name }) => {
	const handleSeen = async (id) => {
		try {
			const res = await AxiosInstance({
				method: "patch",
				url: `/api/v1/reviews/${id}`,
				headers: {
					"Content-Type": "application/json",
				},
				data: {
					read: true,
				},
			});

			toast(res.data.message);
			window.location.assign("/admin/reviews");
		} catch (err) {
			if (err?.response?.data?.message) {
				toast.error(err.response.data.message, { position: "top-center" });
			}
		}
	};
	const handleDelete = async (id) => {
		try {
			const res = await AxiosInstance({
				method: "delete",
				url: `/api/v1/reviews/${id}`,
				headers: {
					"Content-Type": "application/json",
				},
				data: {
					read: true,
				},
			});

			toast(res.data.message);
			window.location.assign("/admin/reviews");
		} catch (err) {
			if (err?.response?.data?.message) {
				toast.error(err.response.data.message, { position: "top-center" });
			}
		}
	};
	return (
		<div>
			<div className="container">
				<div className="review-box">
					<div>
						<h5 className="text-center" style={{ color: "orangered" }}>
							{" "}
							{name}
						</h5>
						<p className="review-comments">
							<span>
								<b>Comment:</b>{" "}
							</span>
							{review.review}
						</p>
					</div>
					<div className="review-flex">
						<div>
							<p className="review-rating">
								<b>Rating:</b>{" "}
								<span style={{ color: "brown" }}>{review.rating}/5</span>{" "}
							</p>
							<p className="review-name">
								<b>By:</b> <span>{review?.author}</span>{" "}
							</p>
							<p className="review-name">
								<b>Ref_number:</b> <span>{review?.ref_num}</span>{" "}
							</p>
							<p className="review-date ">
								{myformat(review?.createdAt, "mmmm dS, yyyy, h:MM:ss TT")}
							</p>
						</div>
						<div>
							{review?.read ? (
								<Button
									style={{ marginLeft: 3, color: "#ff0000" }}
									onClick={() => handleDelete(review?._id)}
								>
									{" "}
									delete
								</Button>
							) : (
								<Button
									style={{ marginLeft: 10 }}
									onClick={() => handleSeen(review?._id)}
								>
									{" "}
									Mark-As-Seen
								</Button>
							)}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};
